import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// The choices a person makes on a page (the month, the project, a tab) live in the address bar, so a
// reload or a copied link opens the same view and Back steps through the choices.
//
// `update` changes several choices in one go: a key set to null (or left empty) is removed, and nothing is
// written when nothing changed, so pressing the same thing twice does not fill the history. Each change
// is a new history entry unless `replace` is asked for.
export function useUrlState() {
  const [params, setParams] = useSearchParams();

  const update = useCallback(
    (patch: Record<string, string | null>, options?: { replace?: boolean }) => {
      const next = new URLSearchParams(params);
      for (const [key, value] of Object.entries(patch)) {
        if (value === null || value === '') next.delete(key);
        else next.set(key, value);
      }
      if (next.toString() === params.toString()) return;
      setParams(next, { replace: options?.replace });
    },
    [params, setParams]
  );

  return { params, update };
}
